﻿var digitalvalidationNemId = (function () {

	/**
		*	digitalvalidationInitNemIdLogin
		*/
    var digitalvalidationInitNemIdLogin = function () {
        window.addEventListener("message", digitalvalidationHandleOnNemIDMessage);
	};

	/**
		*	digitalvalidationHandleSsn
		*	@param {Event} e
		*/
    var digitalvalidationHandleSsn = function (e) {
		e.preventDefault();
		var
		/** @type {Object} oInput */
		oInput = document.getElementById("digitalvalidation-ssnnumber"),
		/** @type {Object} oData */
		oData = { CPR: oInput.value, AccessToken: oInput.getAttribute("data-token") };

		if (/\d{10}/.test(oInput.value)) {
			oInput.classList.remove("input-validation-error");
			_digitalvalidationXhrPost(this.getAttribute("data-posturl"), oData, digitalvalidationHandleLogin, [this], "NemID CPR fejl", true);
		}
		else {
			oInput.classList.add("input-validation-error");
		}
	};

	/**
		*	digitalvalidationHandleLogin
		*	@param {Object} oForm
		*	@param {Object} oData
		*/
    var digitalvalidationHandleLogin = function (oForm, oData) {
        digitalvalidationHandleNemIDLogin(oData);
	};

	/**
		*	digitalvalidationHandleOnNemIDMessage
		*	@param {Object} e
		*/
    var digitalvalidationHandleOnNemIDMessage = function (e) {
		try {
		    var oFrame = document.getElementById("digitalvalidation-nemid-iframe").contentWindow;
		    var sURIPrefix = document.getElementById("digitalvalidation-loginContainer").getAttribute("data-urlprefix");
			if (e.origin !== sURIPrefix) {
				return false;
			}

			var oMsg = {};
			try {
				oMsg = JSON.parse(e.data);
			}
			catch (err) {
				//if this is not a nemid message return
				return;
			}

			if (oMsg.command == "SendParameters") {
				var oPostMsg = {};
				oPostMsg.command = "parameters";
				oPostMsg.content = document.getElementById("digitalvalidation-nemid-parameters").innerHTML;
				oFrame.postMessage(JSON.stringify(oPostMsg), sURIPrefix);
			}

			if (oMsg.command == "changeResponseAndSubmit") {
			    var submitUrl = document.getElementById("digitalvalidation-loginContainer").getAttribute("data-submiturl");
			    var blockid = document.getElementById("digitalvalidation-loginContainer").getAttribute("data-blockid");

				if (!submitUrl) {
					alert('nemid submiturl missing!');
				}
				else {
				    _digitalvalidationXhrPost(submitUrl, { secret: oMsg.content, blockid: blockid }, digitalvalidationHandleNemIDLogin, null, "NemID Message fejl", true);
				}
			}
		}
		catch (err) { }
	};

	/**
	*	digitalvalidationHandleNemIDLogin
	*	@param {Object} oData
	*/
    var digitalvalidationHandleNemIDLogin = function (oData) {
		oData = JSON.parse(oData);
		if (oData && oData.success) {
		    //submit the form in digitalvalidation flow when we are logged in and do not need a cpr
		    var form = document.getElementById("digitalvalidation-form");
                if (form) {
                    form.submit();
				}
		}
		else {
			/** @type {Object} oWrap */
		    var oWrap = document.getElementById("loginNemidMessage");
		    document.getElementById("digitalvalidation-nemid-iframe").style.display = "none";
			if (oWrap) {
				oWrap.innerHTML = oData.errorMessage;
			}
		}
	};

	/**
    * _digitalvalidationXhrPost
    * @param {string} sURI
    * @param {Object} oData
    * @param {Function} fCallBack
    * @param {?} [oArgs] CallBack-Arguments
    * @param {string} [sErr]
    * @param {boolean} [bErrNemID]
    * @param {boolean} [bShowModal]
    */
    var _digitalvalidationXhrPost = function (sURI, oData, fCallBack, oArgs, sErr, bErrNemID, bShowModal) {
		var
		/** @type {Array} aArg */
		aArg,
		/** @type {Object} oModal */
		//oModal = document.querySelector(".modal-dialog"),
		/** @type {Object} oRequest */
		oReq = new XMLHttpRequest();

		sErr = typeof sErr !== "undefined" ? sErr : "Timeout.";
		bShowModal = typeof bShowModal !== "undefined" ? bShowModal : false;
		//if (bShowModal) oModal.classList.remove("hide");

		oReq.open("POST", sURI, true);
		oReq.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
		oReq.onload = function () {
			if (oReq.status == 200) {
				if (oArgs) {
					aArg = Array.isArray(oArgs) ? oArgs : Array.prototype.slice.call(oArgs);

					if (typeof oReq.response !== "undefined") {
						aArg.push(oReq.response);
					}
					else {
						aArg.push(oReq.responseText);
					}

					//oModal.classList.add("hide");
					fCallBack.apply(null, aArg);
				}
				else {
					//oModal.classList.add("hide");

					if (typeof oReq.response !== "undefined") {
						fCallBack(oReq.response);
					}
					else {
						fCallBack(oReq.responseText);
					}
				}
			}
			else {
				var oWrap = document.querySelector(".login-message");
				//oModal.classList.add("hide");
				if (oWrap) { oWrap.innerHTML = sErr; }
			}
		};
		oReq.timeout = 12000;
		oReq.ontimeout = function () {
		    if (oReq) oReq.abort();
		    document.getElementById("digitalvalidation-nemid-iframe").style.display = "none";
			var
			/** @type {Object} oWrap */
		    oWrap = bErrNemID ? document.getElementById("loginNemidMessage") : document.querySelector(".login-message");
			//oModal.classList.add("hide");
			if (oWrap) { oWrap.innerHTML = sErr; }
		};

		oReq.onerror = function () {
			var
			/** @type {Object} oWrap */
		    oWrap = bErrNemID ? document.getElementById("loginNemidMessage") : document.querySelector(".login-message");
			//oModal.classList.add("hide");
			if (oWrap) { oWrap.innerHTML = sErr; }
		};
		oReq.send(JSON.stringify(oData));
	};

	// expose functions
	return {
	    digitalvalidationInitNemIdLogin: digitalvalidationInitNemIdLogin
	};

})();

document.addEventListener("DOMContentLoaded", function () {
	// initialize
    digitalvalidationNemId.digitalvalidationInitNemIdLogin();
});